// vue-callgraph-plugin.js
import { wrap, CallGraph } from './callgraph'

function getComponentName(thisVm) {
    const comp = thisVm?.$options || {};
    if (comp.name) return comp.name;
    const file = comp.__file || comp.__name || '';
    if (file) {
        const base = file.split(/[\\/]/).pop() || '';
        return base.replace(/\.\w+$/, '') || '(anonymous)';
    }
    return '(anonymous)';
}

export function createVueCallgraphPlugin(cg) {
  return {
    install(app) {
        app.mixin({
            beforeCreate() {
                const comp = this.$options;
                const compName = getComponentName(this);

                // ✅ 1) Идемпотентность: помечаем, что уже обернули этот компонент
                if (comp.__cgWrapped) {
                    return;
                }
                comp.__cgWrapped = true;       
                
                const meta = {};
                const widget_id = this?.widget_id||this?.$props?.widget_id||''
                const attr_id = this?.attr_id||this?.$props?.attr_id||''
                if (widget_id) {
                    meta.widget_id = widget_id

                    const WIDGET = this.store?.findWidget?.(widget_id)?.WIDGET   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: hotfix — пустые граф и матрица связей): компонент с widget_id без store (GraphPanelIsland) ронял beforeCreate → пустой граф и матрица
                    if (WIDGET) {
                        let attr_inContent = this?.$props?.initialAttr
                        if (!attr_inContent && attr_id) {
                            attr_inContent = this.store?.widget_attr?.(WIDGET, attr_id)?.attr   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: hotfix — пустые граф и матрица связей)
                            if (attr_inContent?.binding) {
                                meta.binding = attr_inContent.binding
                                // meta.attr_id = attr_id
                            }
                        }
                    }
                }

                // ✅ 2) Оборачиваем методы (один раз на компонент)
                if (comp.methods) {
                    for (const method of Object.keys(comp.methods)) {
                        const orig = comp.methods[method];
                        if (typeof orig === 'function' && !orig.__cgWrapped) {
                            comp.methods[method] = wrap(cg, `${compName}.${method}`, orig, {...meta, file:compName, name:method});
                            comp.methods[method].__cgWrapped = true;
                        }
                    }
                }

                // ✅ 3) Оборачиваем lifecycle-хуки (один раз на компонент)
                const hooks = ['created','mounted','updated','unmounted','beforeMount','beforeUpdate'];
                for (const hook of hooks) {
                    const arr = comp[hook];
                    if (Array.isArray(arr)) {
                        comp[hook] = arr.map(fn => {
                            if (typeof fn === 'function' && !fn.__cgWrapped) {
                            const w = wrap(cg, `${compName}::${hook}`, fn, {...meta, file:compName, name:hook});
                            w.__cgWrapped = true;
                            return w;
                            }
                            return fn;
                        });
                    } else if (typeof arr === 'function' && !arr.__cgWrapped) {
                        const w = wrap(cg, `${compName}::${hook}`, arr, {...meta, file:compName, name:hook});
                        w.__cgWrapped = true;
                        comp[hook] = w;
                    }
                }

                // ✅ 4) Правильная подмена setup: оборачиваем возвращаемые функции один раз
                if (typeof comp.setup === 'function' && !comp.setup.__cgPatched) {
                    const origSetup = comp.setup;
                    comp.setup = function(...args) {
                        const ret = origSetup.apply(this, args);
                        if (ret && typeof ret === 'object') {
                            for (const [k, v] of Object.entries(ret)) {
                                if (typeof v === 'function' && !v.__cgWrapped) {
                                    ret[k] = wrap(cg, `${compName}.setup:${k}`, v, {...meta, file:compName, name:`setup:${k}`});
                                    ret[k].__cgWrapped = true;
                                }
                            }
                        }
                        return ret;
                    };
                    comp.setup.__cgPatched = true;
                }
                },

                // ❌ Эту секцию оставляем пустой, чтобы не дублировать логику setup
                setup(props, ctx) {
                // здесь ничего не делаем — setup уже подменён в beforeCreate
                return undefined;
                },
            });

            // Печать дерева
            app.config.globalProperties.$printCallTree = (opts) => {
                console.log(cg.render_tree(opts).call_tree_text);
            };
            window.$printCallTree = (opts) => console.log(cg.render_tree(opts).call_tree_text);

            app.config.globalProperties.$callgraph = cg;
            window.$cg = cg;
        }
    };
}